module.exports = __webpack_public_path__ + "img/versionBanner2.0b3cf164.jpg";